import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { WindowService } from "src/shared/providers/window.service";

@Component({
    selector: 'tidy-goal-tasks-card',
    templateUrl: './goal-tasks-card.html',
    styleUrls: ['./goal-tasks-card.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class GoalTasksCardComponent implements OnInit {
  
  @Input() goal: any;
  @Input() isUnchosenGoal: boolean;
  @Input() goals: any[];
  @Output() goToTaskDetails = new EventEmitter<Task>();
  @Output() updateGoal = new EventEmitter<any>();
  @Output() openVideo = new EventEmitter<any>();

  constructor(
    public windowService: WindowService
  ) {}

  ngOnInit(): void {
    // No initialization needed
  }

  toggleGoalExpansion(goal) {
    goal.isOpened = !goal.isOpened;
    this.goals.map(g => {
      if (g !== goal) {
        g.isOpened = false;
      }
    });
    // Persist expanded goal ID to localStorage
    if (goal.isOpened) {
      localStorage.setItem('onboarding_expanded_goal_id', goal.id?.toString() || '');
    } else {
      localStorage.removeItem('onboarding_expanded_goal_id');
    }
  }

  sortSteps(steps) {
    return [...steps].sort((a, b) => {
      if (a.state === b.state) {return 0;}
      return a.state === 'done' ? 1 : -1;
    });
  }
}
